module.exports = __webpack_public_path__ + "static/img/baguette.ab2b20a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cover/baguette.jpg
// module id = U4SU
// module chunks = 1